import { render, staticRenderFns } from "./ServiceGroupTile.vue?vue&type=template&id=08acc7a5&scoped=true&"
import script from "./ServiceGroupTile.vue?vue&type=script&lang=js&"
export * from "./ServiceGroupTile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08acc7a5",
  null
  
)

export default component.exports